import { LawDetails } from "../types/lawTypes";

export const lawInitialValues: LawDetails = {
  description: "",
  files: [],
  file: {
    fileId: "",
    fileName: "",
    fileSize: 0,
    contentType: "",
    rootDirectory: "",
    relativePath: "",
    additionalMetadata: null,
  },
};
